import { http } from "./Http";

// AM2202
export const GetReadPriceAPIforSimulation = (
  query_parameters: any,
  config: any
) => {
  const { baseURLShop, token, affiliate_cd } = config;
  const param = {
    token: token,
    url: `${baseURLShop}/v1/prices/${affiliate_cd}?${query_parameters}`,
    config: config,
  };
  return http(param);
};
